const binding = { modules: {}, dataActions: {} };

    (binding.modules['catalog-link-repairer'] = {
        c: () => require('partner/modules/catalog-link-repairer/catalog-link-repairer.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'catalog-link-repairer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/catalog-link-repairer'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };